/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WidgetNavigationDescriptor {
    getFixupPrototypeFunction() { return WidgetNavigationDescriptor.fixupPrototype; }

    static newInstance(model: Partial<WidgetNavigationDescriptor>): WidgetNavigationDescriptor {
        let obj = Object.assign(new WidgetNavigationDescriptor(), model);
        WidgetNavigationDescriptor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WidgetNavigationDescriptor>): WidgetNavigationDescriptor {
        if (!model) return null;
        return WidgetNavigationDescriptor.newInstance(<WidgetNavigationDescriptor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WidgetNavigationDescriptor) {
        if (!obj) return;

        models.WidgetNavigationDescriptor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WidgetNavigationDescriptor): boolean {
        Object.setPrototypeOf(obj, WidgetNavigationDescriptor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Context of the navigation if the Widget supports more than one (e.g. columns)
     */
    context: string;

    /**
     * Path of the portal to navigate to
     */
    portal_path: Array<string>;

}
